import axios from "axios";

export default {

    namespaced: true,
    state: {
        accionesNoValidas: [],
        accionesEditadas: [],
        loadingValidacion: false,
        contratosValidos: []
    },
    mutations: {
        SET_ACCIONES_NO_VALIDAS(state, newValue) {
            state.accionesNoValidas = JSON.parse(JSON.stringify(newValue))
            state.accionesNoValidas.map(accion => {
                accion.contrato = []
                accion.ambito = []
                return accion
            })
            // state.accionesNoValidas = [...newValue]
        },
        SET_ACCIONES_EDITADAS(state, newValue) {
           // state.accionesEditadas = JSON.parse(JSON.stringify(newValue))
             state.accionesEditadas = [...newValue]
        },
        SET_LOADING(state, value) {
            state.loadingValidacion = value
        },
        SET_CONTRATOS_VALIDOS(state, value) {
            state.contratosValidos = JSON.parse(JSON.stringify(value))

            //state.contratosValidos = value
        }
    },
    actions: {
        reset({
            commit
        }) {
            commit('SET_CONTRATOS_VALIDOS', [])
            commit('SET_ACCIONES_EDITADAS', [])
            commit('SET_ACCIONES_NO_VALIDAS', [])
        },
        setContratosValidos({
            commit
        }, {
            contratos
        }) {
            commit('SET_CONTRATOS_VALIDOS', contratos)
        },
        getContratosValidos({
            commit,
            dispatch
        }, {
            cliente,
            parte_id = undefined,
            tipoParte_id = null
        }) {
            commit('SET_LOADING', true)
            return axios
                .get(
                    // `/api/contratos?codCliente=${cliente}&parteId=${this.parteSeleccionado[0].id}`
                    `/api/contratos?codCliente=${cliente}${parte_id!==undefined?`&parteId=${parte_id}`:''}`
                )
                .then((respuesta) => {
                    const contratosValidos = respuesta.data.filter((contrato) =>
                        tipoParte_id !== null ?
                        contrato.id === tipoParte_id || contrato.siempreVisible :
                        contrato.activo
                    );
                    commit('SET_CONTRATOS_VALIDOS', contratosValidos)
                })
                .catch((error) => {
                    dispatch('setSnackbar', {
                        tipo: "error",
                        mensaje: `Error. No se han podido cargar los contratos del cliente ${cliente} ${parte_id!==undefined?` y parte ${parte_id}`:``}`,
                    }, {
                        root: true
                    })
                }).finally(() => {
                    commit('SET_LOADING', false)
                })
        },
        setAccionesNoValidas({
            commit,
            state
        }, {
            acciones
        }) {
            const accionesNoValidas = acciones.filter(accion => {
                return !state.contratosValidos.find(contrato => contrato.id === accion.contrato.id)
            })
            
            commit('SET_ACCIONES_NO_VALIDAS', accionesNoValidas)
            // commit('SET_LOADING', true)
            // commit('SET_LOADING', false)
        },
        setAccionesEditadas({
            commit
        }, {
            acciones
        }) {
            commit('SET_ACCIONES_EDITADAS', acciones)
        }
    },
    getters: {

        isValid: state => (state.accionesNoValidas.length === 0 || state.accionesEditadas.length > 0) && (!state.accionesEditadas.filter(accion => {
            return !state.contratosValidos.find(contrato => contrato.id === accion.contrato.id) || !accion.contrato.ambitos.find(ambito => ambito.id === accion.ambito.id)
            // return !state.contratosValidos.find(contrato => contrato.id === accion.contrato.id) || accion.ambito === ""
        }).length),
        loadingValidacion: state => state.loadingValidacion,
        accionesNoValidas: state => state.accionesNoValidas,
        accionesEditadas: state => state.accionesEditadas,
        contratosValidos: state => state.contratosValidos,
        contratosValidosTexto: state => {
            const contratos = state.contratosValidos.map(contrato => contrato.contrato)
            return contratos.slice(0, -1).join(', ') + ' o ' + contratos.slice(-1)
        }
    }
}